/*
 * @Author: your name
 * @Date: 2020-12-08 15:22:28
 * @Description: 路由配置最终出口
 * @FilePath: /hsylc2021/src/router/index.js
 */
import Vue from 'vue';
import VueRouter from 'vue-router';
import Test from './test';
import Common from './common';
import Inner from './inner';
import Student from './student';
import Course from './course';
import Volunteer from './volunteer';
import School from './school';
import SL from './sl';
import Poster from './poster';
import Teacher from './teacher';
import CheckIn from './checkin';
import Dashboard from './dashboard';
import Sbp from './sbp';
import TOP_BARS from '../utils/topBars';
import FOOTERS from '@footers';
import Activities from './activities';
import Gio from '../utils/gio';
import Campus from './campus';
import HWeek from './hweek';
import DeansList from './deansList';
import WeCom from './wecom';
import Mini from './mini';
import Calendar from './calendar';

import Login from '../utils/login';
import ROLE from '../utils/roles';

import STORE from '../store';
import { cleanCache } from '../api/caches';
Vue.use(VueRouter);

//获取原型对象上的push函数
const originalPush = VueRouter.prototype.push;
//修改原型对象中的push方法
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};

let routes = [
  ...Inner,
  ...Common,
  ...Student,
  ...Volunteer,
  ...School,
  ...SL,
  ...Poster,
  ...Teacher,
  ...CheckIn,
  ...Dashboard,
  ...Calendar,
  ...Course,
  ...Sbp,
  ...Activities,
  ...Campus,
  ...HWeek,
  ...DeansList,
  ...WeCom,
  ...Mini,
  ...Test
];
routes.push(
  /**
   * @description 首页
   * @function / 首页
   * @param {Component} Home views/common/Home
   * @param {Name} pathname Home
   */
  {
    path: '/',
    name: 'Home',
    meta: {
      topBar: TOP_BARS.INDEX,
      footer: FOOTERS.DEFAULT
    },
    component: () => import('../views/common/Home')
  },
  /**
   * @description 落地页
   * @function / 落地页
   * @param {Component} Home views/common/Home
   * @param {Name} pathname Home
   */
  {
    path: '/land-page',
    name: 'LandPage',
    meta: {
      topBar: TOP_BARS.NULL,
      footer: FOOTERS.NULL,
      title: '2025哈佛HSYLC峰会'
    },
    component: () => import('../views/LandPage')
  },
  /**
   * @description 哈佛寄语活动页
   * @function /Harvard_greetings 哈佛寄语
   * @param {Component} HarvardGreetings views/Activities/HarvardGreetings
   * @param {Name} pathname harvard-greetings
   */
  {
    path: '/Harvard_greetings',
    name: 'harvard-greetings',
    meta: {
      topBar: TOP_BARS.NULL,
      footer: FOOTERS.NULL,
      title: '哈佛寄语'
    },
    component: () => import('../views/Activities/HarvardGreetings')
  },
  /**
   * @description 微信openid中间页
   * @function /wx-code-redirect 微信openid中间页
   * @param {Component} WechatCodeHelper
   * @param {Name} pathname weChatCodeHelper
   */
  {
    path: '/wx-code-redirect',
    name: 'weChatCodeHelper',
    component: () => import('../views/common/WechatCodeHelper.vue')
  },
  /**
   * @func /wx-code 微信获取openid
   * @param { Component } Signup views/Frame/WXCode
   * @param { Name } pathname wx-code
   */
  {
    path: '/wx-code/:url',
    name: 'wx-code',
    component: () => import('../views/common/WXCode.vue')
  },
  /**
   * @func /innersecurity innersecurity
   * @param { Component } Security views/Error/Security
   * @param { Name } pathname innersecurity
   */
  {
    path: '/innersecurity',
    name: 'innersecurity',
    component: () => import('views/Error/Security')
  },
  {
    path: '/amcsecurity',
    name: 'amcsecurity',
    component: () => import('views/Error/AMCSecurity')
  },
  {
    path: '/pdf/:src',
    name: 'pdf',
    meta: {
      topBar: TOP_BARS.NULL,
      footer: FOOTERS.NULL
    },
    component: () => import('../views/PDF')
  },
  {
    path: '/checklist',
    name: 'checklist',
    meta: {
      topBar: TOP_BARS.NULL,
      footer: FOOTERS.NULL
    },
    component: () => import('../views/PDF/Checklist')
  },
  {
    path: '/roster',
    name: 'roster',
    component: () => import('../views/common/Roster'),
    meta: {
      topBar: TOP_BARS.NULL,
      footer: FOOTERS.NULL
    }
  },
  {
    path: '/roster/:placeName',
    name: 'roster-em-ma',
    component: () => import('../views/common/Roster/EM_MA'),
    meta: {
      topBar: TOP_BARS.NO_USER
    }
  }
);
routes.push(
  /**
   * @description 404
   * @function 404 404
   * @param {Component} Home views/common/404.vue
   * @param {Name} pathname Page404
   */
  {
    path: '*',
    name: 'Page404',
    meta: {
      title: '404'
    },
    component: () => import('../views/common/404.vue')
  },
  /**
   * @description 404
   * @function 404 404
   * @param {Component} Home views/common/404.vue
   * @param {Name} pathname Page404
   */
  {
    path: '/loading',
    name: 'loading',
    meta: {
      title: '加载中...'
    },
    component: () => import('../views/common/Loading')
  },
  /**
   * @description 变身 身份
   * @function /agreement 变身 身份
   * @param {Component} Agreement views/common/changeId
   * @param {Name} pathname agreement
   */
  {
    path: '/changeId',
    name: 'changeId',
    meta: {
      title: '变身'
    },
    component: () => import('../views/common/ChangeId.vue')
  },
  {
    path: '/demo/im',
    name: 'im',
    component: () => import('../views/Demo/IM')
  }
);

const router = new VueRouter({
  mode: 'history',
  routes
});
router.beforeEach(async (to, from, next) => {
  cleanCache();
  // STORE.dispatch('cleanLoginData');
  if (to.meta.role === ROLE.STUDENT) {
    await stuApplyStatus();
  }
  if (to.meta.title) {
    document.title = `华夏基金·2027哈佛HSYLC峰会-${to.meta.title}`;
  } else {
    document.title = '华夏基金·2027哈佛HSYLC峰会';
  }
  if (to.meta.description) {
    document.description = to.meta.description;
  }
  if (to.meta.keywords) {
    document.keywords = to.meta.keywords;
  }
  next();
  // Vue.prototype.$webfont.submit();
  // 获取学生状态 跳到 对应页面
  // await getStudentsStatus(to, from, next);
  // console.log('登入状态 schoolLoginData：', Store.state.schoolLoginData);
  // next();
});

router.afterEach(async () => {
  Login.getCommonLoginData();
  let $app = document.getElementById('app');
  if ($app && $app.scrollTo && typeof $app.scrollTo === 'function') {
    $app.scrollTo(0, 0);
  }
  Gio.sendUser();
});

async function stuApplyStatus() {
  let status = await Login.getStatusData(ROLE.STUDENT, true);
  // console.log('用户状态-after:', status);
  // console.log('STORE-dispatch-setStuProcess', status);

  STORE.dispatch('setStuProcess', status);
}
export default router;
